import { type MetaFunction } from '@remix-run/node'
import travelers from './travelers.png'

export const meta: MetaFunction = () => [
	{ title: 'Travelers' },
	{
		name: 'description',
		content: 'We offer insurance from Travelers.',
	},
]

export default function Component() {
	return (
		<main className="mx-auto my-10 max-w-7xl">
			<h1 className="py-3 text-4xl font-black">Travelers</h1>
			<p
				data-paragraph
				className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
			>
				<img src={travelers} alt="Travelers" className="w-64" />
				<h3>History</h3>
				<p
					data-paragraph
					className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
				>
					In 1853, the St Paul Fire &amp; Marine Insurance company was formed.
					That company would later grow to become what we now call Travelers.
					Over the years, Travelers has been and remains an industry leader.
				</p>
				<h3>Products</h3>
				<p
					data-paragraph
					className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
				>
					Travelers has departments that handle both personal and business
					insurance. For families and individuals, you'll find great homeowner's
					and automobile offerings, and business owners will be pleased with
					what they can do for your business.
				</p>
				<h3>Financial Strength</h3>
				<p
					data-paragraph
					className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
				>
					Travelers is proud to carry the financial strength rating of A+
					(Superior) from the rating agency A.M. Best. This rating was assigned
					because of their superior financial stability and market position.
				</p>
				<h3>Contact Information</h3>
				<p
					data-paragraph
					className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
				>
					Website:{' '}
					<a
						href="https://www.travelers.com/"
						target="_blank"
						rel="noopener noreferrer"
					>
						https://www.travelers.com/ (opens in a new tab)
					</a>
				</p>
				<h3>Claims</h3>
				<p
					data-paragraph
					className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
				>
					(800) 252-4633
				</p>
				<h3>Make a Payment</h3>
				<p
					data-paragraph
					className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
				>
					<a
						title="MyTravelers Account Management Webpage"
						href="https://selfservice.travelers.com/"
						target="_blank"
						rel="noopener noreferrer"
					>
						https://selfservice.travelers.com/ (opens in a new tab)
					</a>
					<br />
					<br />
					Billing Address:
					<br />
					Attn: Remittance Center
					<br />
					One Tower Square
					<br />
					Hartford, CT 06183
				</p>
			</p>

			<section>
				<h3>Home Office Address</h3>

				<p
					data-paragraph
					className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
				>
					Travelers
					<br />
					One Tower Square
					<br />
					Hartford, CT 06183
				</p>
			</section>
		</main>
	)
}
